
<div class="recent-grid">

    <div class="projects">
        <div class="card">
            <div class="card-body">

                <div class="">
                    <p class="titulo-card-amarillo">Datos de la Unidad Educativa</p>

                    <table class="table-info">
                        <tr>
                            <td>
                                <p class="table-row-title">Código:</p>
                            </td>
                            <td>{{uniEducativa.rbd}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Nombre:</p>
                            </td>
                            <td>{{uniEducativa.nombreJardin}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Programa:</p>
                            </td>
                            <td>{{uniEducativa.programa}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Modalidad:</p>
                            </td>
                            <td>{{uniEducativa.modalidad}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Teléfono:</p>
                            </td>
                            <td>{{uniEducativa.telefono}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Dirección:</p>
                            </td>
                            <td>{{uniEducativa.direccion}}</td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">Comuna:</p>
                            </td>
                            <td>{{uniEducativa.comuna}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Región:</p>
                            </td>
                            <td>{{uniEducativa.region}}</td>
                        </tr>
                    </table>

                </div>
            </div>

        </div>
    </div>

    <div class="identification">

        <div class="card">


            <div class="card-body">
                <div>
                    <p class="titulo-card-amarillo">Historial</p>
                    <table class="table-info">
                        <tr>
                            <td>
                                <p class="table-row-title">PUNTAJES MGCEP</p>
                            </td>
                            <td>
                                <p class="table-row-title">7 APLICACIÓN</p>
                            </td>
                            <td>
                                <p class="table-row-title">8 APLICACIÓN</p>
                            </td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-text-normal">Área 1: Liderazgo</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea1}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea1}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-text-normal">Área 2: Gestión Pedagógica</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea2}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea2}}</p>
                            </td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-text-normal">Área 3: Familia y Comunidad</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea3}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea3}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-text-normal">Área 4: Bienestar Integral</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea4}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea4}}</p>
                            </td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-text-normal">Área 5: Gestión de Recursos</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea5}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea5}}</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <p class="table-text-normal">Área 6: Resultados</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2017?.puntajeArea6}}</p>
                            </td>
                            <td>
                                <p class="table-text-normal">{{historialData?.historial2020?.puntajeArea6}}</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <p class="table-row-title">PUNTAJE TOTAL</p>
                            </td>
                            <td>
                                <p class="table-text-color">{{historialData?.historial2017?.puntajeTotal}}</p>
                            </td>
                            <td>
                                <p class="table-text-color">{{historialData?.historial2020?.puntajeTotal}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="table-row-title">NIVEL DE CALIDAD</p>
                            </td>
                            <td>
                                <p class="table-text-color">{{historialData?.historial2017?.nivelCalidad}}</p>
                            </td>
                            <td>
                                <p class="table-text-color">{{historialData?.historial2020?.nivelCalidad}}</p>
                            </td>
                        </tr>
                    </table>
                    <br>

                </div>
            </div>
        </div>
    </div>


</div>





<ngx-spinner></ngx-spinner>